import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  templateUrl: 'form-card-wrapper.component.html',
  styleUrls: ['form-card-wrapper.component.scss'],
})
export class FormCardWrapperComponent extends FieldWrapper {
}
